import { gql } from '@apollo/client';
import { useEdeMutation, useEdeQueryName } from 'routes/marketplace-ede/context/edeQueryProvider';

const queryType = 'SUBMIT_ENROLLMENT';

const useSubmitEnrollmentMutation = (options) => {
  const queryName = useEdeQueryName(queryType);

  const SUBMIT_ENROLLMENT_MUTATION = gql`
  mutation SubmitEnrollment(
    $applicationId: ID!
    $payload: [EnrollmentGroup!]!
    $agencyId: ID
    $agentId: ID
  ) {
    ${queryName}(
      applicationId: $applicationId
      payload: $payload
      agencyId: $agencyId
      agentId: $agentId
    )
  }
`;

  return useEdeMutation(SUBMIT_ENROLLMENT_MUTATION, options);
};

export default useSubmitEnrollmentMutation;
